import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid'
import EditService from './EditService';
import { useEffect, useState } from 'react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ListServices(props) {
  // let servicesListFromProps = props.servicesList;
  // 
  const [servicesList, setServicesList] = useState([]);
  const [showEditService, setShowEditService] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    setServicesList(props.servicesList);
  } , [props.servicesList]);

  return (
    <>
    {!showEditService ? 
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {servicesList.map((service) => (
          <li key={service.name} className="col-span-1 divide-y divide-gray-200 rounded-lg bg-sec-dark shadow-md shadow-pri-dark-shadow active:translate-y-1 active:shadow-none">
            <div  onClick={() => {setSelectedService(service); setShowEditService(true)} }className="flex w-full items-center justify-between space-x-6 p-6">
              <div className="flex-1 truncate">
                <div className="flex items-center space-x-3">
                  <h3 className="truncate text-xl font-medium text-pri-white">{service.name}</h3>
                  <span className={classNames(
                        service.status === "enabled" ? 'ring-pri-dark-shadow text-pri-dark-shadow' : 'ring-pri-yellow text-pri-yellow',
                        'inline-flex flex-shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-pri-dark-shadow ring-1 ring-inset'
                      )}>
                    {service.status}
                  </span>
                </div>
                <p className="mt-1 truncate text-sm text-pri-white">{service.description}</p>
              </div>
              <img className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300" src={service.image_url} alt="" />
            </div>
          </li>
        ))}
      </ul>
      </div> : null }
      <div>
        {showEditService ? <EditService 
                              serviceDetails={selectedService}
                              servicesList={servicesList}
                              setShowEditService={setShowEditService} 
                              setServicesList={setServicesList}/> 
                            : null}
      </div>
    </>
  )

}
